<div
  class="upload-section"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onFileDrop($event)"
  [class.drag-over]="isDragOver"
>
  <tech-file-uploader techFileUploaderSize="lg" techFileUploadercolor="success">
    <input
      id="fileUpload"
      type="file"
      (change)="onFileSelected($event)"
      accept=".csv,.xlsx,.json,.txt"
      class="upload-input"
    />
  </tech-file-uploader>
</div>
